import { t } from "@lingui/macro";
import { createId } from "@paralleldrive/cuid2";
import { Plus } from "@phosphor-icons/react";
import { Button } from "@stylingcv/ui";

import { useResumeStore } from "@/client/stores/resume";

export const SocialMediaButtons = () => {
  const setValue = useResumeStore((state) => state.setValue);
  const customFields = useResumeStore((state) => {
    try {
      return state.resume.data.basics.customFields;
    } catch {
      return [];
    }
  });

  const addSocialMediaField = (name: string, icon: string, urlPrefix = "") => {
    setValue("basics.customFields", [
      ...customFields,
      { id: createId(), icon, name, value: urlPrefix, isSocial: true },
    ]);
  };

  // ✅ FIXED: Move social media buttons inside component to fix translation hashing
  const socialMediaButtons = [
    { name: t`LinkedIn`, icon: "linkedin-logo", urlPrefix: "https://linkedin.com/in/" },
    { name: t`Twitter`, icon: "twitter-logo", urlPrefix: "https://twitter.com/" },
    { name: t`Github`, icon: "github-logo", urlPrefix: "https://github.com/" },
    { name: t`Youtube`, icon: "youtube-logo", urlPrefix: "https://youtube.com/@" },
    { name: t`Behance`, icon: "behance-logo", urlPrefix: "https://behance.net/" },
    { name: t`Dribbble`, icon: "dribbble-logo", urlPrefix: "https://dribbble.com/" },
    {
      name: t`Stack Overflow`,
      icon: "stack-overflow-logo",
      urlPrefix: "https://stackoverflow.com/users/",
    },
    { name: t`Instagram`, icon: "instagram-logo", urlPrefix: "https://instagram.com/" },
    { name: t`Facebook`, icon: "facebook-logo", urlPrefix: "https://facebook.com/" },
  ];

  // Filter out social media buttons that are already added
  const availableSocialButtons = socialMediaButtons.filter(
    (social) =>
      !customFields.some((field: any) => field.name === social.name.toString() && field.isSocial),
  );

  if (availableSocialButtons.length === 0) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
      {availableSocialButtons.map((social) => (
        <Button
          key={social.name.toString()}
          variant="outline"
          className="flex items-center justify-start rounded bg-gray-100 px-2 py-1 dark:bg-gray-800"
          onClick={() => {
            addSocialMediaField(social.name.toString(), social.icon, social.urlPrefix);
          }}
        >
          <Plus size={16} className="me-1" />

          {social.name === t`LinkedIn` && <i className="ph ph-linkedin-logo ms-1 text-lg" />}
          {social.name === t`Twitter` && <i className="ph ph-twitter-logo ms-1 text-lg" />}
          {social.name === t`Github` && <i className="ph ph-github-logo ms-1 text-lg" />}
          {social.name === t`Youtube` && <i className="ph ph-youtube-logo ms-1 text-lg" />}
          {social.name === t`Behance` && <i className="ph ph-behance-logo ms-1 text-lg" />}
          {social.name === t`Dribbble` && <i className="ph ph-dribbble-logo ms-1 text-lg" />}
          {social.name === t`Stack Overflow` && (
            <i className="ph ph-stack-overflow-logo ms-1 text-lg" />
          )}
          {social.name === t`Instagram` && <i className="ph ph-instagram-logo ms-1 text-lg" />}
          {social.name === t`Facebook` && <i className="ph ph-facebook-logo ms-1 text-lg" />}
          <span className="ms-1">{social.name}</span>
        </Button>
      ))}
    </div>
  );
};
